<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined>
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Avtividad:</h3>
          </v-col>

          <v-col cols="12" xl="8" md="8" sm="8" xs="12">
            <v-text-field
              ref="name"
              v-model="name"
              outlined
              :maxlength="100"
              :counter="100"
              :rules="[v => (v || '' ).length <= 99 || 'El nombre del día no debe tener mas de 100 caracteres']"
              label="Nombre del día"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-text-field
              type="date"
              v-model="date"
              outlined
              append-icon="mdi-calendar"
              label="Fecha de la actividad"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_btn"
        color="primary"
        :to="{ name: 'programEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_btn"
        color="primary"
        @click="updateprogram()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'editProgramEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      edition_id:null,
      program_id: null,

      program:[],

      name:null,
      date:null
    }),

    methods:{
      async getProgram()
      {
        await axios.get('admin/editions/'+this.edition_id+'/program-edition/'+this.program_id).then(response =>{
          this.program = response.data.data.program
          this.name = this.program.name
          this.date = this.program.date

          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      async updateprogram()
      {
        this.loading_btn = true

        let formData= new FormData()

        if(this.name){
          formData.append('name', this.name)
        }

        if(this.date){
          formData.append('date', this.date);
        }

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/program-edition/'+this.program_id,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.dialog_new = false
            this.loading_btn = false
            this.loading = true
            this.$router.push({ name: 'programEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          this.dialog_new_edition = false
          this.loading_btn = false
          console.log('Response: ')
          console.error(error.response.data);
        }
      }
    },
    created(){
      this.edition_id = this.$route.params.edition_id
      this.program_id = this.$route.params.program_id
      this.getProgram()
    },
  }
</script>
